import { alpha, Theme } from "@mui/material/styles";

export const useStyle = (theme: Theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    height: "100%",
  },
  paper: {
    padding: 2,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    gap: 1,
    width: "100%",
    overflowY: "auto",
  },
  rowContainer: {
    display: "flex",
    gap: 2,
    flexDirection: { xs: "column", md: "row" },
    width: "100%",
  },
  variableContainer: {
    display: "grid",
    gap: 2,
    alignItems: "center",
    gridTemplateColumns: {
      xs: "1fr",
      sm: "1fr 1fr",
      lg: "1fr 1fr 1fr 1fr auto",
    },
    width: "100%",
    "& > *": {
      width: { xs: "100%", md: "auto" },
    },
  },
  multiBox: {
    backgroundColor: theme.palette.background.textField,
    alignItems: "center",
    justifyContent: "center",
    pl: 2,
    borderRadius: 1,
    height: "45px",
  },
  iconButton: { fontSize: 30, ml: 1, color: theme.palette.error.main },
  monacoContainer: {
    height: { xs: 650, md: 600 },
    p: 0,
    borderRadius: 1,
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: 2, md: 0 },
  },
  monacoCard: {
    width: { xs: "100%", md: "50%" },
    height: { xs: "45%", md: "100%" },
    display: "flex",
    flexDirection: "column",
    borderRadius: 2,
    boxShadow: 2,
    bgcolor: theme.palette.background.card,
    border: `1px solid ${theme.palette.divider}`,
    overflow: "hidden",
    mb: { xs: 2, md: 0 },
  },
  monacoHeader: {
    bgcolor: theme.palette.background.card,
    color: theme.palette.text.primary,
    borderRadius: 1,
    px: 2,
    py: 1,
    borderBottom: `2px solid ${theme.palette.divider}`,
    letterSpacing: 1,
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
    fontSize: 18,
    gap: 2,
    position: "relative",
  },
  headerButton: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    right: 10,
  },
  terminal: {
    flex: 1,
    p: 2,
    color: theme.palette.text.primary,
    fontSize: 13,
    bgcolor: theme.palette.background.terminal,
    maxWidth: "100%",
    minWidth: 0,
    width: "100%",
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
    overflowX: "auto",
    overflowY: "auto",
    boxSizing: "border-box",
  },
  terminalText: {
    m: 0,
    fontFamily: "monospace",
    fontSize: 13,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
    maxWidth: "100%",
    minWidth: 0,
    width: "100%",
  },
  buttonContainer: { display: "flex", justifyContent: "end", gap: 2 },
  cancelButton: {
    backgroundColor: theme.palette.background.textField,
    color: theme.palette.text.primary,
    "&:hover": {
      backgroundColor: alpha(theme.palette.background.textField, 0.5),
    },
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
  },
  autocomplete: {
    "& .MuiAutocomplete-input": {
      minHeight: "unset !important",
      padding: "4px 4px !important",
    },
    "& .MuiAutocomplete-tag": {
      maxWidth: 175,
      maxHeight: 30,
      margin: "2px",
    },
  },
  boxTitle: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    color: theme.palette.text.secondary,
  },
  tabs: {
    "&": {
      minHeight: "36px !important",
    },
    "& button": {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.secondary,
      padding: "0px !important",
      textTransform: "none",
      transition: "background 0.2s",
      borderRadius: "6px 6px 0 0 !important",
      minHeight: 36,
      height: 36,
    },
    "& .MuiTabs-flexContainer": {
      height: "36px",
    },
    "& button.Mui-selected": {
      backgroundColor: alpha(theme.palette.primary.main, 0.12),
      color: theme.palette.primary.main,
      boxShadow: `0 2px 8px ${alpha(theme.palette.primary.main, 0.08)}`,
      zIndex: 1,
      position: "relative",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
      height: "3px",
      bottom: 0,
    },
  },
  previewContainer: {
    flex: 1,
    width: { xs: "100%", md: "50%" },
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // borderLeft: { xs: "none", md: `1px solid ${theme.palette.divider}` },
    border: `1px solid ${theme.palette.divider}`,
    fontSize: "5rem",
    overflow: "hidden",
  },
});
